// src/encounter/structured-note/chart-filled-line.tsx
//
// PROD-3040 · L1 · frame v2: a template item the chart already answers, drawn READ-ONLY with its source.
// Never an askable control: the clinician sees the value and "From the chart" (ENC-L1). The answer itself is
// written to the response by the note (structured-note-section.tsx), so a score adds its points and the
// generated note documents it.
import { NoteLine, type QItem } from '@scripsteam/scrips-signal-ds';
import { V2_META } from '../lib/design-v2';
import { CHART_SOURCE_LABEL, type ChartFill } from '../lib/chart-population';
import { chartFillDisplay } from './chart-fill-context';
import { NoteLabel } from './label-parts';

export function ChartFilledLine({ id, item, label, fill }: { id: string; item: QItem; label: string; fill: ChartFill }) {
  return (
    <div id={id} data-note-row data-chart-filled={item.linkId}>
      <NoteLine label={<NoteLabel label={label} />} align="center" valueClassName="flex flex-wrap items-center gap-2">
        <span className="font-sans text-body-15 text-text-primary" aria-readonly="true">
          {chartFillDisplay(item, fill.value)}
        </span>
        <span className={V2_META} data-testid="chart-source">
          {CHART_SOURCE_LABEL}
        </span>
      </NoteLine>
    </div>
  );
}
